'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Image from 'next/image';
import { useSearchParams, usePathname, useRouter } from 'next/navigation';
import { useSession } from 'next-auth/react';
import FavoritesModalImage from '@/app/_components/FavoritesModalImage';
import { useState, useCallback, useEffect, useRef } from 'react';
import '@/app/_styles/react-modal-slide-panel.css';
import '@/app/_styles/react-modal-favorites.css';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveHeartLight, faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import { faHeart } from '@awesome.me/kit-94e593bf23/icons/classic/solid';
import { faXmark, faPlus } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faTrash } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import FavoritesListSelect from '@/app/_components/FavoritesListSelect';
import SubmitWithPendingButton from '@/app/_components/SubmitWithPendingButton';
import addFavoritesListAction from '@/app/_lib/actions/AddFavoritesListAction';
import addFavoriteAction from '@/app/_lib/actions/AddFavoriteAction';
import deleteFavoriteAction from '@/app/_lib/actions/DeleteFavoriteAction';
import { decodeEntities } from '@/app/_lib/services/ClientUtil';
import Price from '@/app/_components/Price';
import { useAppContext } from '@/app/_lib/_context';
import { useGlobalMessage, useFavorites } from '@/app/_lib/hooks';
import getSubProductBasicAction from '@/app/_lib/actions/GetSubProductBasicAction';
const FavoritesModal = t0 => {
  const $ = _c(89);
  const {
    isOpen,
    setIsOpen,
    contentLabel,
    modalData: t1,
    addClasses: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const modalData = t3;
  t2 === undefined ? "" : t2;
  const router = useRouter();
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  useEffect(_temp, t4);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  let t5;
  if ($[3] !== searchParams) {
    t5 = new URLSearchParams(searchParams);
    $[3] = searchParams;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const params = t5;
  const {
    isFavorite: checkIsFavorite,
    refresh: refreshFavorites
  } = useFavorites();
  const {
    data: session
  } = useSession();
  const addGlobalMessage = useGlobalMessage();
  const [subProduct, setSubProduct] = useState(false);
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const [favoritesLists, setFavoritesLists] = useState(t6);
  useState(1);
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  useState(t7);
  const [selectedList, setSelectedList] = useState(false);
  const [originalList, setOriginalList] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const [addListPending, setAddListPending] = useState(false);
  const [selectTitle, setSelectTitle] = useState("Select a list");
  let t8;
  if ($[7] !== checkIsFavorite || $[8] !== modalData.sub_product_id) {
    t8 = async () => {
      setSubProduct(false);
      setIsFavorite(false);
      setSelectedList(false);
      setOriginalList(false);
      setSelectTitle("Select a list");
      const setUp = async () => {
        const sub_product_id = modalData.sub_product_id;
        const [favoritesListsRes, subProductResponse] = await Promise.all([fetch("/api/favorites/lists"), sub_product_id ? getSubProductBasicAction(sub_product_id) : Promise.resolve(null)]);
        const favoritesListsResponse = await favoritesListsRes.json();
        let lists = [];
        if (favoritesListsResponse.success && favoritesListsResponse.favorites_lists) {
          lists = favoritesListsResponse.favorites_lists.map(_temp2);
          setFavoritesLists(lists);
        }
        if (subProductResponse?.success && subProductResponse.sub_product) {
          setSubProduct(subProductResponse.sub_product);
          if (checkIsFavorite(sub_product_id)) {
            setIsFavorite(true);
            setSelectTitle(lists.length > 1 ? "Move to a different list" : "Saved to");
          }
          let foundInList = false;
          lists.forEach(list_0 => {
            const favorite_index = list_0.favorites.indexOf(sub_product_id);
            if (favorite_index !== -1) {
              setSelectedList(list_0);
              setOriginalList(list_0);
              foundInList = true;
            }
          });
        }
      };
      await setUp();
    };
    $[7] = checkIsFavorite;
    $[8] = modalData.sub_product_id;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const afterOpenModal = t8;
  let t9;
  if ($[10] !== modalData || $[11] !== setIsOpen) {
    t9 = t10 => {
      const moveInfo = t10 === undefined ? null : t10;
      if (modalData.onClose) {
        modalData.onClose(moveInfo);
      }
      setIsOpen(false);
      setSelectedList(false);
      setOriginalList(false);
    };
    $[10] = modalData;
    $[11] = setIsOpen;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const closeModal = t9;
  let t10;
  if ($[13] !== addGlobalMessage || $[14] !== refreshFavorites || $[15] !== subProduct) {
    t10 = async t11 => {
      const {
        sub_product_id: sub_product_id_0,
        list_index,
        list_name: t12
      } = t11;
      const list_name = t12 === undefined ? false : t12;
      const requestData = {
        sub_product_id: sub_product_id_0,
        list_index
      };
      const addFavoriteResponse = await addFavoriteAction(requestData);
      if (addFavoriteResponse.success) {
        if (list_name && subProduct) {
          const message = decodeEntities(subProduct.sub_product_name) + " was added to " + list_name;
          addGlobalMessage({
            message,
            messageType: "success"
          });
          setSelectTitle(`Saved to ${list_name}`);
        }
        refreshFavorites();
        setIsFavorite(true);
      }
      return addFavoriteResponse;
    };
    $[13] = addGlobalMessage;
    $[14] = refreshFavorites;
    $[15] = subProduct;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const addFavorite = t10;
  let t11;
  if ($[17] !== addGlobalMessage || $[18] !== refreshFavorites || $[19] !== subProduct.sub_product_id || $[20] !== subProduct.sub_product_name) {
    t11 = async formData => {
      const list_name_0 = formData.get("list_name");
      if (!list_name_0 || !list_name_0.trim()) {
        addGlobalMessage({
          message: "Please enter a list name.",
          messageType: "error"
        });
        return;
      }
      setAddListPending(true);
      const requestData_0 = {
        list_name: list_name_0.trim(),
        sub_product_id: subProduct.sub_product_id
      };
      const addFavoritesListResponse = await addFavoritesListAction(requestData_0);
      if (addFavoritesListResponse.success && addFavoritesListResponse.favorites_lists) {
        const newListIndex = addFavoritesListResponse.list_index;
        localStorage.setItem("lastFavoritesListIndex", newListIndex);
        const lists_0 = addFavoritesListResponse.favorites_lists.map(_temp3);
        const newList = lists_0.find(l => l.list_index === newListIndex);
        setSelectedList(newList);
        setFavoritesLists(lists_0);
        refreshFavorites();
        setIsFavorite(true);
        setSelectTitle(`Saved to ${list_name_0.trim()}`);
        addGlobalMessage({
          message: `${decodeEntities(subProduct.sub_product_name)} was added to ${list_name_0.trim()}`,
          messageType: "success"
        });
      } else {
        if (addFavoritesListResponse.errors) {
          const errorMessage = Object.values(addFavoritesListResponse.errors)[0] || "An error occurred.";
          addGlobalMessage({
            message: errorMessage,
            messageType: "error"
          });
        }
      }
      setAddListPending(false);
    };
    $[17] = addGlobalMessage;
    $[18] = refreshFavorites;
    $[19] = subProduct.sub_product_id;
    $[20] = subProduct.sub_product_name;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const handleAddListSubmit = t11;
  let t12;
  if ($[22] !== addFavorite || $[23] !== isFavorite || $[24] !== originalList || $[25] !== subProduct) {
    t12 = async (list_2, index) => {
      setSelectedList(list_2);
      if (subProduct && (!isFavorite || originalList && originalList.list_index !== list_2.list_index)) {
        const actualListIndex = list_2.list_index;
        localStorage.setItem("lastFavoritesListIndex", actualListIndex);
        await addFavorite({
          sub_product_id: subProduct.sub_product_id,
          list_index: actualListIndex,
          list_name: list_2.list_name
        });
      }
    };
    $[22] = addFavorite;
    $[23] = isFavorite;
    $[24] = originalList;
    $[25] = subProduct;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const handleSelectList = t12;
  let t13;
  if ($[27] !== addGlobalMessage || $[28] !== closeModal || $[29] !== originalList || $[30] !== refreshFavorites || $[31] !== subProduct) {
    t13 = async () => {
      const response = await deleteFavoriteAction(subProduct.sub_product_id);
      if (response.success) {
        if (response.favorites_lists) {
          setFavoritesLists(response.favorites_lists);
        }
        refreshFavorites();
        setSelectedList(false);
        const message_0 = decodeEntities(subProduct.sub_product_name) + " was removed from your favorites.";
        addGlobalMessage({
          message: message_0,
          messageType: "success"
        });
        const moveInfo_0 = {
          sub_product: subProduct,
          sub_product_id: subProduct.sub_product_id,
          from_list_index: originalList ? originalList.list_index : null,
          to_list_index: null,
          action: "remove"
        };
        closeModal(moveInfo_0);
      } else {
        addGlobalMessage({
          message: response.message,
          messageType: "error"
        });
        closeModal(null);
      }
    };
    $[27] = addGlobalMessage;
    $[28] = closeModal;
    $[29] = originalList;
    $[30] = refreshFavorites;
    $[31] = subProduct;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  const removeFavorite = t13;
  let t14;
  if ($[33] !== closeModal || $[34] !== params || $[35] !== pathname || $[36] !== router) {
    t14 = event => {
      params.delete("favorites");
      params.delete("id");
      router.replace(`${pathname}?${params.toString()}`, {
        scroll: false
      });
      closeModal();
    };
    $[33] = closeModal;
    $[34] = params;
    $[35] = pathname;
    $[36] = router;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const handleRequestCloseFavoritesModal = t14;
  let t15;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <FontAwesomeIcon icon={faXmark} className="text-lg" />;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== closeModal) {
    t16 = <button type="button" onClick={closeModal} className="hidden md:flex absolute -top-4 -right-4 w-8 h-8 items-center justify-center bg-white rounded-full shadow-lg text-dark hover:text-primary transition-colors z-10" aria-label="Close">{t15}</button>;
    $[39] = closeModal;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex items-center"><FontAwesomeIcon icon={faHiveHeartLight} aria-hidden="true" className="text-xl mr-2 block" /><span className="text-md">Favorites</span></div>;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <FontAwesomeIcon icon={faXmark} aria-hidden="true" className="text-[28px] block" />;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== closeModal) {
    t19 = <div className="shrink-0 flex items-center justify-between site-padding py-3 border-b border-gray-8 bg-gray-3 leading-none md:hidden">{t17}<button type="button" onClick={closeModal} className="text-light hover:text-primary flex items-center" aria-label="Close">{t18}</button></div>;
    $[43] = closeModal;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <FavoritesModalImage alt="Manage favorites" />;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="hidden md:flex items-center gap-3 mb-3"><FontAwesomeIcon icon={faHiveIconSmallLight} aria-hidden="true" className="text-2xl text-[#F5A623]" /><h2 className="text-2xl md:text-3xl font-extralight">Favorites</h2></div>;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== modalData.sub_product_id || $[48] !== subProduct) {
    t22 = !subProduct && modalData.sub_product_id && <div className="flex items-center mb-6"><div className="skeleton w-[75px] h-[75px] rounded mr-8" /><div className="flex-1"><div className="skeleton h-4 w-3/4 rounded mb-2" /><div className="skeleton h-3 w-1/2 rounded mb-1" /><div className="skeleton h-3 w-1/3 rounded mb-1.5" /><div className="skeleton h-4 w-16 rounded" /></div></div>;
    $[47] = modalData.sub_product_id;
    $[48] = subProduct;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== closeModal || $[51] !== subProduct) {
    t23 = subProduct && subProduct.url && subProduct.url != "" && <div className="flex items-center mb-6">{subProduct.thumb_1 && <Link href={subProduct.url} onClick={closeModal}><Image className="scale-100 min-w-[75px] min-h-[75px] lg:transition-all lg:duration-500 lg:group-hover:scale-110 mr-8" src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/thumbs/${subProduct.thumb_1}`} overrideSrc={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/thumbs/${subProduct.thumb_1}`} alt={decodeEntities(subProduct.sub_product_name)} placeholder="blur" blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII=" width={75} height={75} quality={90} /></Link>}{!subProduct.thumb_1 && subProduct.product_photo && subProduct.product_photo != "" && <Link href={subProduct.url} onClick={closeModal}><Image className="scale-100 min-w-[75px] min-h-[75px] lg:transition-all lg:duration-500 lg:group-hover:scale-110 mr-4" src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${subProduct.product_photo}`} overrideSrc={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${subProduct.product_photo}`} alt={decodeEntities(subProduct.sub_product_name)} placeholder="blur" blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII=" width={75} height={75} quality={90} /></Link>}<div><Link href={subProduct.url} onClick={closeModal} className="block text-sm font-medium text-light capitalize mb-1">{decodeEntities(subProduct.sub_product_name)}</Link>{(() => {
          const lowestPrice = parseFloat(subProduct.lowest_price) || 0;
          const highestPrice = parseFloat(subProduct.highest_price) || 0;
          const retailPrice = parseFloat(subProduct.retail_price) || 0;
          const hasPriceRange = lowestPrice > 0 && highestPrice > 0 && highestPrice > lowestPrice;
          const onSale = subProduct.on_sale == 1 && subProduct.discount_rate && parseFloat(subProduct.discount_rate) < 1;
          const discountRate = parseFloat(subProduct.discount_rate) || 1;
          if (hasPriceRange) {
            const saleLowest = onSale ? lowestPrice * discountRate : lowestPrice;
            const saleHighest = onSale ? highestPrice * discountRate : highestPrice;
            return <div className="text-sm font-light mb-1"><span className={onSale ? "text-dark" : ""}><Price amount={saleLowest} /> - <Price amount={saleHighest} /></span>{onSale && <div className="line-through text-light text-2xs"><Price amount={lowestPrice} /> - <Price amount={highestPrice} /></div>}</div>;
          } else {
            const salePrice = onSale ? retailPrice * discountRate : retailPrice;
            return <div className="text-sm font-light mb-1"><span className={onSale ? "text-dark" : ""}><Price amount={salePrice} /></span>{onSale && <div className="line-through text-light text-2xs"><Price amount={retailPrice} /></div>}</div>;
          }
        })()}{(subProduct.supplier_name || subProduct.designer_name) && <div className="flex items-center">{subProduct.supplier_name && <span className={`text-3xs font-medium ${subProduct.designer_name ? "border-r-1 pr-2 mr-2" : ""}`}>{subProduct.supplier_name}</span>}{subProduct.designer_name && <span className="text-3xs text-light">{subProduct.designer_name}</span>}</div>}</div></div>;
    $[50] = closeModal;
    $[51] = subProduct;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== isFavorite || $[54] !== removeFavorite) {
    t24 = isFavorite && <button onClick={removeFavorite} className="btn btn-sm btn-default w-full mb-8"><FontAwesomeIcon icon={faTrash} aria-hidden="true" className="mr-1" />Remove From Favorites</button>;
    $[53] = isFavorite;
    $[54] = removeFavorite;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== favoritesLists || $[57] !== handleSelectList || $[58] !== selectTitle || $[59] !== selectedList) {
    t25 = <div className="mb-6"><FavoritesListSelect identifier="favorites-modal" label={selectTitle} options={favoritesLists} selectedOption={selectedList} onSelect={handleSelectList} showHeartOnSelected={true} className="w-full" /></div>;
    $[56] = favoritesLists;
    $[57] = handleSelectList;
    $[58] = selectTitle;
    $[59] = selectedList;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== addListPending || $[62] !== handleAddListSubmit || $[63] !== session) {
    t26 = session && <><p className="text-sm text-gray-600 mb-2">Create a new list:</p><form action={handleAddListSubmit}><div className="w-full flex items-center"><div className="form-group flex-1 mr-2"><input id="favorites_list_name" type="text" name="list_name" className="w-full form-input form-input-sm peer" placeholder=" " required={true} /><label htmlFor="favorites_list_name" className="form-input-label form-input-label-sm peer-placeholder-shown:form-input-label-placeholder-shown">New List Name</label></div><SubmitWithPendingButton isPending={addListPending} pendingText="Creating..." icon={faPlus} size="sm" className="w-auto">Create List</SubmitWithPendingButton></div></form></>;
    $[61] = addListPending;
    $[62] = handleAddListSubmit;
    $[63] = session;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== t22 || $[66] !== t23 || $[67] !== t24 || $[68] !== t25 || $[69] !== t26) {
    t27 = <div>{t21}{t22}{t23}{t24}{t25}{t26}</div>;
    $[65] = t22;
    $[66] = t23;
    $[67] = t24;
    $[68] = t25;
    $[69] = t26;
    $[70] = t27;
  } else {
    t27 = $[70];
  }
  let t28;
  if ($[71] !== closeModal || $[72] !== modalData.hide_manage_button) {
    t28 = !modalData.hide_manage_button && <Link href="/favorites" className="group text-2xs text-dark hover:text-light leading-relaxed mb-4 inline-block transition-colors" onClick={closeModal}><FontAwesomeIcon icon={faHiveHeartLight} aria-hidden="true" className="mr-1 group-hover:text-red transition-colors" /> View Favorites</Link>;
    $[71] = closeModal;
    $[72] = modalData.hide_manage_button;
    $[73] = t28;
  } else {
    t28 = $[73];
  }
  let t29;
  if ($[74] !== t28) {
    t29 = <div className="mt-6 mb-4 md:mb-0">{t28}</div>;
    $[74] = t28;
    $[75] = t29;
  } else {
    t29 = $[75];
  }
  let t30;
  if ($[76] !== t27 || $[77] !== t29) {
    t30 = <div className="flex flex-col md:flex-row h-full md:h-auto overflow-y-auto md:overflow-visible">{t20}<div className="w-full md:w-1/2 px-6 py-5 md:pt-5 pb-16 md:pb-3 relative flex flex-col justify-between order-1 md:order-2">{t27}{t29}</div></div>;
    $[76] = t27;
    $[77] = t29;
    $[78] = t30;
  } else {
    t30 = $[78];
  }
  let t31;
  if ($[79] !== t16 || $[80] !== t19 || $[81] !== t30) {
    t31 = <div className="relative h-full md:h-auto">{t16}{t19}{t30}</div>;
    $[79] = t16;
    $[80] = t19;
    $[81] = t30;
    $[82] = t31;
  } else {
    t31 = $[82];
  }
  let t32;
  if ($[83] !== afterOpenModal || $[84] !== contentLabel || $[85] !== handleRequestCloseFavoritesModal || $[86] !== isOpen || $[87] !== t31) {
    t32 = <Modal overlayClassName="slide-panel favorites-modal z-[1055] fixed outline-0 inset-0 md:bg-modal-overlay md:flex md:items-center md:justify-center" className={"favorites-modal-content fixed outline-none bg-white shadow-2xl\n                inset-0 top-[var(--header-height)] [body.header-collapsed_&]:top-[var(--header-height-collapsed)]\n                md:static md:w-[calc(100%-var(--site-padding)*2)] md:max-w-[800px] md:max-h-[calc(100vh-4rem)] md:rounded-sm md:overflow-visible"} isOpen={isOpen} onAfterOpen={afterOpenModal} contentLabel={contentLabel} onRequestClose={handleRequestCloseFavoritesModal} closeTimeoutMS={500} bodyOpenClassName="ReactModal__Body--open" htmlOpenClassName="ReactModal__Html--open">{t31}</Modal>;
    $[83] = afterOpenModal;
    $[84] = contentLabel;
    $[85] = handleRequestCloseFavoritesModal;
    $[86] = isOpen;
    $[87] = t31;
    $[88] = t32;
  } else {
    t32 = $[88];
  }
  return t32;
};
export default FavoritesModal;
function _temp() {
  Modal.setAppElement("#app");
}
function _temp2(list) {
  return {
    ...list,
    option_name: list.list_name
  };
}
function _temp3(list_1) {
  return {
    ...list_1,
    option_name: list_1.list_name
  };
}